import actions from './actions';
import getters from './getters';
import mutations from './mutations';

// initial state
const state: example.state.ExampleState = {};

export default {
    state,
    actions,
    getters,
    mutations,
};
